module.exports = __webpack_public_path__ + "img/pn.727b5344.svg";